//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import formIcon from "@/components/ObjectForm";
import { PSWRULE } from "@/libs/validate1";
export default {
  components: {
    formIcon: formIcon
  },
  data: function data() {
    var _this = this;
    var confirmPwd = function confirmPwd(rule, value, callback) {
      if (value !== _this.userInfo.isPwd) {
        callback(new Error("请保持与新密码输入一致。"));
      } else {
        callback();
      }
    };
    return {
      userInfo: {
        oldPwd: "",
        newPwd: "",
        isPwd: ""
      },
      rules: {
        oldPassWord: [{
          required: true,
          message: "请输入原始密码",
          trigger: "blur"
        }, {
          validator: PSWRULE,
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "请输入新密码",
          trigger: "blur"
        }, {
          validator: PSWRULE,
          trigger: "blur"
        }],
        isPwd: [{
          required: true,
          message: "请输入确认密码",
          trigger: "blur"
        }, {
          validator: confirmPwd,
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    submit: function submit(val) {
      var _this2 = this;
      this.$refs[val].validate(function (valid) {
        if (valid) {
          var v = JSON.parse(JSON.stringify(_this2.userInfo));
          v.password = _this2.$md5(_this2.userInfo.password);
          v.oldPassWord = _this2.$md5(_this2.userInfo.oldPassWord);
          _this2.$store.dispatch("user/upDateUserInfo", v).then(function (res) {
            console.log(res);
            _this2.$message.success("修改成功。");
            _this2.$store.dispatch("user/logout");
          });
        } else {
          _this2.$message.error("修改失败，请先检查填写信息");
        }
      });
    },
    resetForm: function resetForm(val) {
      this.$refs[val].resetFields();
    }
  }
};